import React from "react";
import "../landing.css";
import styled from "styled-components";
import youtube from "../../../asset/ces/ces-icon-btn_youtube-dark.png";
import youtubeDarkHover from "../../../asset/ces/ces-icon-btn_youtube-dark-hover.png";
import youtubeDarkActive from "../../../asset/ces/ces-icon-btn_youtube-dark-active.png";
import instagram from "../../../asset/ces/ces-icon-btn_insta-dark.png";
import instagramDarkHover from "../../../asset/ces/ces-icon-btn_insta-dark-hover.png";
import instagramDarkActive from "../../../asset/ces/ces-icon-btn_insta-dark-active.png";
import linkedin from "../../../asset/ces/btn_linkedin=Default.png";
import linkedinHover from "../../../asset/ces/btn_linkedin=hover.png";
import linkedinActive from "../../../asset/ces/btn_linkedin=pressed.png";

const YoutubeIcon = styled.img`
  width: 48px;
  height: 48px;
  cursor: pointer;

  &[src="${youtube}"] {
    content: url(${youtube});
    &:hover {
      content: url(${youtubeDarkHover});
    }
    &:active {
      content: url(${youtubeDarkActive});
    }
  }
`;

const InstagramIcon = styled.img`
  width: 48px;
  height: 48px;
  margin-left: 8px;
  cursor: pointer;

  &[src="${instagram}"] {
    content: url(${instagram});
    &:hover {
      content: url(${instagramDarkHover});
    }
    &:active {
      content: url(${instagramDarkActive});
    }
  }
`;

const LinkedinIcon = styled.img`
  width: 48px;
  height: 48px;
  margin-left: 8px;
  cursor: pointer;

  &[src="${linkedin}"] {
    content: url(${linkedin});
    &:hover {
      content: url(${linkedinHover});
    }
    &:active {
      content: url(${linkedinActive});
    }
  }
`;

const SNS = () => {
  React.useEffect(() => {
    // 모든 이미지 프리로드
    const images = [
      youtube,
      youtubeDarkHover,
      youtubeDarkActive,
      instagram,
      instagramDarkHover,
      instagramDarkActive,
      linkedin,
      linkedinHover,
      linkedinActive,
    ];

    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <div className="landing-section-sns">
      <h1 className="landing-section-title">SNS</h1>
      <div className="sns-container">
        <YoutubeIcon
          src={youtube}
          alt="youtube"
          onClick={() =>
            window.open("https://www.youtube.com/@MINDSAI.Official", "_blank")
          }
        />
        <InstagramIcon
          src={instagram}
          alt="instagram"
          onClick={() =>
            window.open(
              "https://www.instagram.com/minds.ai.official/",
              "_blank",
            )
          }
        />
        <LinkedinIcon
          src={linkedin}
          alt="linkedin"
          onClick={() =>
            window.open("https://www.linkedin.com/company/mindsai/", "_blank")
          }
        />
      </div>
    </div>
  );
};

export default SNS;
